import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { I18nService } from '../../core/i18n.service';
import { PageSection } from '../page-section/page-section';

@Component({ selector: 'app-forgot-password', standalone: true, imports: [FormsModule, RouterLink, PageSection], templateUrl: './forgot-password.html', styleUrl: './forgot-password.scss' })
export class ForgotPassword {
  email = '';
  resetCode = '';
  newPassword = '';
  status: 'idle' | 'invalid' | 'weakPassword' | 'requesting' | 'codeSent' | 'requestFailed' | 'confirming' | 'confirmed' | 'confirmFailed' = 'idle';
  isRequestingReset = false;
  isConfirmingReset = false;

  constructor(public i18n: I18nService, private api: ApiService) {}

  async requestReset(): Promise<void> {
    if (this.isRequestingReset) return;
    if (!this.email.trim()) {
      this.status = 'invalid';
      return;
    }

    this.isRequestingReset = true;
    this.status = 'requesting';
    try {
      await this.api.requestPasswordReset(this.email.trim());
      this.status = 'codeSent';
    } catch {
      this.status = 'requestFailed';
    } finally {
      this.isRequestingReset = false;
    }
  }

  async confirmReset(): Promise<void> {
    if (this.isConfirmingReset) return;
    if (!this.email.trim() || !this.resetCode.trim() || !this.newPassword) {
      this.status = 'invalid';
      return;
    }
    if (!this.meetsPasswordPolicy(this.newPassword)) {
      this.status = 'weakPassword';
      return;
    }

    this.isConfirmingReset = true;
    this.status = 'confirming';
    try {
      await this.api.confirmPasswordReset(this.email.trim(), this.resetCode.trim(), this.newPassword);
      this.resetCode = '';
      this.newPassword = '';
      this.status = 'confirmed';
    } catch {
      this.status = 'confirmFailed';
    } finally {
      this.isConfirmingReset = false;
    }
  }

  private meetsPasswordPolicy(password: string): boolean {
    return password.length >= 12
      && /[a-z]/.test(password)
      && /[A-Z]/.test(password)
      && /\d/.test(password)
      && /[^A-Za-z0-9]/.test(password);
  }
}